import * as EventListener from "../common/helpers/event-listener";
import csrfToken from "../common/helpers/csrf-token";
import { makeFilterUrl } from "../common/helpers/helper";

const login = () => {
    EventListener.submit(
        "loginForm",
        "loginFormError",
        null,
        (formData, button, formError) => {
            oc.ajax("UserLogin::onLogin", {
                data: {
                    _token: csrfToken,
                    email: formData.get("email"),
                    password: formData.get("password"),
                },
                loading: "#loader-line",
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    }
                },
            });
        },
    );
};

const registration = () => {
    EventListener.submit(
        "registrationForm",
        "registrationFormError",
        null,
        (formData, button, formError) => {
            oc.ajax("UserRegistration::onRegister", {
                loading: "#loader-line",
                data: {
                    _token: csrfToken,
                    email: formData.get("email"),
                    phone: formData.get("phone"),
                    first_name: formData.get("first_name"),
                    last_name: formData.get("last_name"),
                    password: formData.get("password"),
                    password_confirmation: formData.get(
                        "password_confirmation",
                    ),
                    is_newsletter: formData.get("is_newsletter"),
                },
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    }
                },
            });
        },
    );
};

const updateData = () => {
    EventListener.submit(
        "updateDataForm",
        "updateDataFormError",
        null,
        (formData, button, formError) => {
            oc.ajax("UserUpdateData::onUpdateData", {
                data: {
                    _token: csrfToken,
                    email: formData.get("email"),
                    phone: formData.get("phone"),
                    first_name: formData.get("first_name"),
                    last_name: formData.get("last_name"),
                },
                loading: "#loader-line",
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    }
                },
            });
        },
    );
};

const changePassword = () => {
    EventListener.submit(
        "changePasswordForm",
        "changePasswordFormError",
        null,
        (formData, button, formError, formMessage, form) => {
            oc.ajax("UserChangePassword::onChangePassword", {
                data: {
                    _token: csrfToken,
                    password: formData.get("password"),
                    password_confirmation: formData.get(
                        "password_confirmation",
                    ),
                },
                loading: "#loader-line",
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    }

                    if (result.status) {
                        form.reset();
                    }
                },
            });
        },
    );
};

const restorePassword = () => {
    EventListener.submit(
        "restorePasswordForm",
        "restorePasswordFormError",
        "restorePasswordFormMessage",
        (formData, button, formError, formMessage, form) => {
            oc.ajax("UserRestorePassword::onRestorePassword", {
                data: {
                    _token: csrfToken,
                    password: formData.get("password"),
                    password_confirmation: formData.get(
                        "password_confirmation",
                    ),
                },
                loading: "#loader-line",
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    } else if (result.status && result.message) {
                        form.remove();
                        formMessage.textContent = result.message;
                    }
                },
            });
        },
    );
};

const resetPassword = () => {
    EventListener.submit(
        "resetPasswordForm",
        "resetPasswordFormError",
        "resetPasswordFormMessage",
        (formData, button, formError, formMessage, form) => {
            oc.ajax("UserResetPassword::onResetPassword", {
                data: {
                    _token: csrfToken,
                    email: formData.get("email"),
                },
                loading: "#loader-line",
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    } else if (result.status && result.message) {
                        formMessage.textContent = result.message;
                    }

                    if (result.status) {
                        form.reset();
                    }
                },
            });
        },
    );
};

const logout = () => {
    EventListener.click("logoutButton", (button) => {
        oc.ajax("UserActions::onLogout", {
            loading: "#loader-line",
            complete: () => {
                button.disabled = false;
            },
        });
    });
};

const deleteUser = () => {
    EventListener.click("deleteButton", (button) => {
        oc.ajax("UserDelete::onDelete", {
            data: { _token: csrfToken },
            loading: "#loader-line",
            complete: () => {
                button.disabled = false;
            },
        });
    });
};

const changeShippingAddressCountry = () => {
    EventListener.change("change-shipping-address-country-select", (select) => {
        oc.ajax("onInit", {
            data: {
                _token: csrfToken,
                country_id: select.value,
            },
            loading: "#loader-line",
            update: {
                "user/shipping-address-district-locality":
                    ".shipping-address-district-locality-wrapper",
            },
            complete: () => {
                select.disabled = false;
            },
        });
    });
};

const changeShippingAddressDistrict = () => {
    EventListener.change(
        "change-shipping-address-district-select",
        (select) => {
            oc.ajax("Settings::onAjax", {
                data: {
                    _token: csrfToken,
                    district_id: select.value,
                },
                loading: "#loader-line",
                update: {
                    "user/shipping-address-locality":
                        ".shipping-address-locality-wrapper",
                },
                complete: () => {
                    select.disabled = false;
                },
            });
        },
    );
};

const updateShippingAddress = () => {
    EventListener.submit(
        "shippingAddressForm",
        "shippingAddressFormError",
        null,
        (formData, button, formError) => {
            oc.ajax("UserUpdateShippingAddress::onUpdateShippingAddress", {
                loading: "#loader-line",
                data: {
                    _token: csrfToken,
                    phone: formData.get("phone"),
                    first_name: formData.get("first_name"),
                    last_name: formData.get("last_name"),
                    address: formData.get("address"),
                    country_id: formData.get("country_id"),
                    district_name: formData.get("district_name"),
                    locality_name: formData.get("locality_name"),
                    district_id: formData.get("district_id"),
                    locality_id: formData.get("locality_id"),
                    shipping_address_id: formData.get("shipping_address_id"),
                },
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    }
                },
            });
        },
    );
};

const deleteShippingAddress = () => {
    EventListener.click("delete-user-shipping-address-button", (button) => {
        oc.ajax("UserDeleteShippingAddress::onDeleteShippingAddress", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                shipping_address_id: button.getAttribute(
                    "data-shipping-address-id",
                ),
            },
            update: {
                "user/shipping-addresses": ".shipping-addresses-wrapper",
            },
            complete: () => {
                button.disabled = false;
            },
        });
    });
};

const updateUserEvent = () => {
    EventListener.submit(
        "userEventForm",
        "userEventFormError",
        null,
        (formData, button, formError) => {
            oc.ajax("UserUpdateUserEvent::onUpdateUserEvent", {
                loading: "#loader-line",
                data: {
                    _token: csrfToken,
                    name: formData.get("name"),
                    reminder: formData.get("reminder"),
                    event_at: formData.get("event_at"),
                    user_event_id: formData.get("user_event_id"),
                },
                complete: (result) => {
                    button.disabled = false;

                    if (!result.status && result.message) {
                        formError.textContent = result.message;
                    }
                },
            });
        },
    );
};

const deleteUserEvent = () => {
    EventListener.click("delete-user-event-button", (button) => {
        oc.ajax("UserDeleteUserEvent::onDeleteUserEvent", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                user_event_id: button.getAttribute("data-user-event-id"),
            },
            complete: () => {
                button.disabled = false;
            },
        });
    });
};

const subscribe = () => {
    EventListener.submit("subscriptionForm", null, null, (formData, button) => {
        oc.ajax("UserActions::onSubscribe", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                email: formData.get("email"),
            },
            complete: (result) => {
                button.disabled = false;

                if (result.status) {
                    document.querySelector(".newsletter-block").remove();
                    document
                        .querySelector(".newsletter-success")
                        .classList.add("show");
                }
            },
        });
    });
};

const agreeWithCookePolicy = () => {
    EventListener.click("userCookiePolicyButton", (button) => {
        document.cookie = "isAgreeWithCookePolicy=1; path=/";
        button.closest(".cookie-block").remove();
    });
};

const changeCurrency = () => {
    EventListener.click("change-currency-button", (button) => {
        oc.ajax("UserActions::onChangeCurrency", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                currency_id: button.getAttribute("data-currency-id"),
            },
            complete: () => {
                button.disabled = false;
            },
        });
    });
};

const ordersListPagination = () => {
    EventListener.click("orders-pagination-button", (button) => {
        const page = button.getAttribute("data-page");

        let requestData = {};

        if (parseInt(page) !== 1) {
            requestData = { ...requestData, page };
        }

        makeFilterUrl(requestData);

        oc.ajax("Settings::onAjax", {
            data: {
                _token: csrfToken,
                page,
            },
            loading: "#loader-line",
            update: { "user/orders": ".order-list-wrapper" },
            complete: () => {
                window.scrollTo(0, 0);
            },
        });
    });
};

const hideOrder = () => {
    EventListener.click("hide-order-button", (button) => {
        const orderId = button.getAttribute("data-order_id");
        const page = 1;

        makeFilterUrl({ page });

        oc.ajax("Orders::onHideOrder", {
            data: {
                _token: csrfToken,
                order_id: orderId,
                page: page,
            },
            loading: "#loader-line",
            update: { "user/orders": ".order-list-wrapper" },
            complete: () => {
                window.scrollTo(0, 0);
                button.disabled = false;
            },
        });
    });
};

const downloadOrderInvoice = () => {
    EventListener.click("download-order-invoice-button", (button) => {
        const orderId = button.getAttribute("data-order_id");

        oc.ajax("OrderPage::onDownloadInvoice", {
            data: {
                _token: csrfToken,
                order_id: orderId,
            },
            loading: "#loader-line",
            download: true,
            complete: () => {
                button.disabled = false;
            },
        });
    });
};

const downloadOrderProforma = () => {
    EventListener.click("download-order-proforma-button", (button) => {
        const orderId = button.getAttribute("data-order_id");

        oc.ajax("OrderPage::onDownloadProforma", {
            data: {
                _token: csrfToken,
                order_id: orderId,
            },
            loading: "#loader-line",
            download: true,
            complete: () => {
                button.disabled = false;
            },
        });
    });
};

const togglePassword = () => {
    EventListener.click("toggle-password", (button) => {
        const input = button.parentElement.querySelector("input");

        if (input.type === "password") {
            input.type = "text";
        } else {
            input.type = "password";
        }

        button.disabled = false;
    });
};

login();
registration();
updateData();
changePassword();
restorePassword();
resetPassword();
logout();
deleteUser();
changeShippingAddressCountry();
changeShippingAddressDistrict();
updateShippingAddress();
deleteShippingAddress();
updateUserEvent();
deleteUserEvent();
subscribe();
agreeWithCookePolicy();
changeCurrency();
ordersListPagination();
hideOrder();
downloadOrderInvoice();
downloadOrderProforma();
togglePassword();
